import styled, { css } from 'styled-components'

export const Container = styled.div`
    padding: 1rem 0;

    h3{
        padding-bottom: 1rem; 
        text-align: center;
    }

    ${props => (props.changeVisibleContent !== 1) && css`
        display: none;
    `}
`
